import { ICategoryItemInput } from '@hts/shared/types';
import { memo } from 'react';

interface ICategoryTitleProps {
  currentActiveCategory: ICategoryItemInput;
  currentActiveSubcategory: string | null;
  toggleFilters: (filter: string, value: string) => void;
}

export const CategoryTitle: React.FC<ICategoryTitleProps> = memo(
  ({ currentActiveCategory, currentActiveSubcategory, toggleFilters }) => {
    return (
      <div className="category-title-holder">
        <h1
          className={
            currentActiveCategory.categories && currentActiveCategory.categories.length > 0
              ? ''
              : 'single-category'
          }
        >
          {currentActiveCategory.name}
        </h1>

        {currentActiveCategory.categories && currentActiveCategory.categories.length > 0 && (
          <div className="subcategory-select-holder">
            <div
              className={
                currentActiveSubcategory
                  ? 'custom-dropdown subcategory-dropdown fixed-active'
                  : 'custom-dropdown subcategory-dropdown'
              }
            >
              <a
                href="/"
                className="custom-dropdown-opener custom-dropdown-opener-changeable active-item"
              >
                {currentActiveSubcategory ?? 'All'}
              </a>

              <div className="custom-dropdown-drop subcategory-drop">
                <ul>
                  {currentActiveCategory.categories.map((item, i) => {
                    return (
                      <li key={`${item.id}-${i}`}>
                        <a
                          href="/"
                          onClick={(e) => {
                            e.preventDefault();
                            toggleFilters('sub', item.slug);
                          }}
                        >
                          {item.name}
                        </a>
                      </li>
                    );
                  })}
                </ul>
              </div>
            </div>
          </div>
        )}
      </div>
    );
  }
);
